/*
 * @Author: 张天昊
 * @Date: 2024-05-30 10:03:05
 * @LastEditTime: 2024-06-04 14:34:25
 * @LastEditors: 张天昊
 * @Description: 用于响应站点服务卡片点击，并分发给各个tab触发Panel的锚定
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useAuxiliaryInfoPanelAnchor.js
 */
import { ref, watch, nextTick } from 'vue';
import { AuxiliaryInfoTypes } from '../constants';
import store from '@/store';

export function useAuxiliaryInfoPanelAnchor(tabActive) {
  // 是一个panelInstance数组
  const panelInsts = ref();

  // 响应站点服务卡片点击
  function handleServiceCardLink(type) {
    const types = [
      null,
      AuxiliaryInfoTypes.旅行社,
      AuxiliaryInfoTypes.导游,
      AuxiliaryInfoTypes.车辆
    ];
    const panelNames = [
      null,
      'TravelAgencyPanel',
      'GuidePanel',
      'VehiclePanel'
    ];
    const targetIndex = types.indexOf(type);
    if (targetIndex > -1) {
      tabActive.value = targetIndex;
      // 要等tab的懒加载渲染结束
      nextTick(() => {
        if (panelInsts.value) {
          const panelName = panelNames[targetIndex];
          const currentPanelInst = panelInsts.value.find(
            (inst) => inst.$options.name === panelName
          );
          if (currentPanelInst && currentPanelInst.anchorTo) {
            // 触发面板的锚定方法
            currentPanelInst.anchorTo();
          }
        }
      });
    }
  }

  watch(tabActive, (value) => {
    // 离开旅行社、导游、车辆这几个tab时要清空store内anchorTarget的记录
    if (![1, 2, 3].includes(value)) {
      store.commit('itineraryUniversal/clearAnchorTarget');
    }
  });

  return {
    panelInsts,
    handleServiceCardLink
  };
}
